import { useTheme } from '@mui/material/styles';
import { OptionCardButton } from 'v3/shared/components/Button/OptionCardButton';
import {
  CloseBox,
  CloseIconStyled,
  Content,
  OptionsContent,
  StyledDialog,
} from 'v3/shared/components/Modal/PixDisplayModeModal/styles';
import { IPixDisplayModeModalProps } from 'v3/shared/components/Modal/PixDisplayModeModal/types';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';

export const PixDisplayModeModal: React.FC<IPixDisplayModeModalProps> = ({
  open,
  setOpenModal,
  onConfirmAndOpenSMSConfirmation,
  openQRCodePix,
}) => {
  const theme = useTheme();

  return (
    <StyledDialog open={open}>
      <Content>
        <CloseBox>
          <CloseIconStyled onClick={() => setOpenModal(false)} aria-label="Fechar modal" />
        </CloseBox>

        <HeadlineSmall color={theme.palette.common.white}>
          Como o cliente deseja receber o QR-Code/Chave Pix?
        </HeadlineSmall>

        <OptionsContent>
          <OptionCardButton
            text={'Exibir QR Code e chave PIX'}
            subtitle="O QR Code e a chave Pix serão exibidos aqui para que você possa mostrar ou copiar para o cliente."
            onClick={() => openQRCodePix()}
          />
          <OptionCardButton
            text={'Enviar por E-mail e SMS'}
            subtitle="O QR Code e a chave Pix serão enviados para o e-mail e celular cadastrados na conta Dimo do cliente."
            onClick={() => onConfirmAndOpenSMSConfirmation()}
          />
        </OptionsContent>
      </Content>
    </StyledDialog>
  );
};